import { render, staticRenderFns } from "./heim-button.vue?vue&type=template&id=05319ac2&scoped=true&"
import script from "./heim-button.vue?vue&type=script&lang=js&"
export * from "./heim-button.vue?vue&type=script&lang=js&"
import style0 from "./heim-button.vue?vue&type=style&index=0&id=05319ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05319ac2",
  null
  
)

component.options.__file = "heim-button.vue"
export default component.exports